import type { MouseEvent } from "react";
import { parseLeadLinks } from "../lead.meta";

export const LeadFromLinks = ({ fromLink }: { fromLink?: string | null }) => {
  const links = parseLeadLinks(fromLink);
  if (!links.length) return null;

  const stopRowClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div className="leadFromLinks">
      {links.map((link) => (
        <a
          key={link}
          className="leadFromLink"
          href={link}
          target="_blank"
          rel="noreferrer"
          onClick={stopRowClick}
        >
          {link}
        </a>
      ))}
    </div>
  );
};
